<template>
  <div>
    <Header></Header>

    <BreadCrumb :host="host" @updatePageTitle="updatePageTitle"></BreadCrumb>

    <div id="itb-page-content">
      <router-view></router-view>
    </div>

    <div v-if="isContactForm">
      <ContactForm @sentGAFormEvent="sentGAFormEvent"></ContactForm>
    </div>

    <Footer></Footer>

    <WelcomeMessage></WelcomeMessage>

    <div id="itb-scroll-up" @click="scrollToElement('app')">
      <img src="/images/icons/4soft_icon_angle-up.svg" class="itb-icon" />
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import BreadCrumb from "../components/BreadCrumb";
import ContactForm from "../components/ContactForm";
import ContactSimpleForm from "../components/ContactSimpleForm";
import Footer from "../components/Footer";
import WelcomeMessage from "../components/WelcomeMessage";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      host: "",
      cookieUserPreference: "",
      googleAnalyticsId: "",
      currentTitle: "",
      isGoogleAnalyticsEnabled: false,
      isChangingRoute: false,
      isProductionEnvironment: false,
    };
  },

  computed: {
    isContactForm: function () {
      return this.$route.name !== "test";
    },

    isSimpleForm: function () {
      return this.$route.name !== "contact";
    },

    isContactForm: function () {
      return this.$route.name !== "graphics";
    },

    isCookieAnalyticsEnabled() {
      let value = false;

      if (this.cookieUserPreference) {
        let cookieUserPreference = JSON.parse(this.cookieUserPreference);
        let acceptedCategories = cookieUserPreference.accepted_categories;
        acceptedCategories.forEach((element) => {
          if (element == "analytics") {
            value = true;
          }
        });
      }

      return value;
    },

    pageViewInfo() {
      return {
        page_title: this.currentTitle,
        page_path: this.$route.path,
        page_location: window.location.href,
        send_page_view: true,
      };
    },
  },

  watch: {
    isCookieAnalyticsEnabled(val) {
      if (val) {
        if (typeof window !== "undefined" && window.gtag) {
          window["ga-disable-GA_MEASUREMENT_ID"] = false;
        } else {
          this.enableGoogleAnalytics();
          window["ga-disable-GA_MEASUREMENT_ID"] = false;
        }
        this.isGoogleAnalyticsEnabled = true;
      } else {
        window["ga-disable-GA_MEASUREMENT_ID"] = true;
        this.isGoogleAnalyticsEnabled = false;
      }
    },

    $route: function (to, from) {
      this.isChangingRoute = true;
    },

    currentTitle(newval, oldval) {
      this.fireGAPageInfoEventWithDelay(1500);
    },
  },

  components: {
    Header,
    BreadCrumb,
    ContactForm,
    ContactSimpleForm,
    Footer,
    WelcomeMessage,
  },

  created() {
    this.getHost();
  },

  mounted() {
    this.setAppParams();

    window.addEventListener(
      "cookie-user-preference-changed",
      this.updateCookieUserPreference
    );

    this.cookieUserPreference = localStorage.getItem("cookieUserPreference");

    //call enableGoogleAnalytics() when hosts is assigned
    this.getGoogleTagInfo();
  },

  destroyed() {
    window.removeEventListener(
      "cookie-user-preference-changed",
      this.updateCookieUserPreference
    );
  },

  methods: {
    ...mapActions(["setAppParams"]),

    scrollToElement(elementId) {
      var element = document.getElementById(elementId);

      if (element) {
        var navbar = document.getElementById("itb-navbar");
        var elementPosition = element.offsetTop;
        var offsetPosition = elementPosition - navbar.offsetHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },

    getHost() {
      axios
        .get("/get-host")
        .then((response) => {
          this.host = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getGoogleTagInfo() {
      axios
        .get("/get-google-tag-info")
        .then((response) => {
          this.googleAnalyticsId = response.data.googleTagId;

          this.isProductionEnvironment = response.data.isOnProduction;

          //For testing only
          // this.isProductionEnvironment = true;

          this.isChangingRoute = true;
          this.enableGoogleAnalytics();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updateCookieUserPreference(event) {
      this.cookieUserPreference = event.detail.storage;
    },

    updatePageTitle(title) {
      this.currentTitle = title;
    },

    fireGAPageInfoEvent() {
      if (this.isGoogleAnalyticsEnabled && this.isProductionEnvironment) {
        this.gtag("event", "page_view", this.pageViewInfo);
        this.isChangingRoute = false;
      }
    },

    fireGAPageInfoEventWithDelay(delay) {
      setTimeout(() => {
        if (this.isChangingRoute) {
          this.fireGAPageInfoEvent();
        }
      }, delay);
    },

    enableGoogleAnalytics() {
      if (this.isCookieAnalyticsEnabled && this.isProductionEnvironment) {
        let gtagScript = document.createElement("script");
        gtagScript.setAttribute(
          "src",
          "https://www.googletagmanager.com/gtag/js?id=" +
            this.googleAnalyticsId
        );
        document.head.appendChild(gtagScript);

        window.dataLayer = window.dataLayer || [];

        this.gtag("js", new Date());

        this.gtag("config", this.googleAnalyticsId, { send_page_view: false });
        this.fireGAPageInfoEventWithDelay(1500);
      }
    },

    gtag: function () {
      dataLayer.push(arguments);
    },

    sentGAFormEvent(formInfo) {
      if (this.isGoogleAnalyticsEnabled && this.isProductionEnvironment) {
        this.gtag("event", "message_sent", formInfo);
      }
    },
  },
};
</script>
